import { createSlice } from "@reduxjs/toolkit";
import { setFichaInfoData } from "./components/fichaInfo/FichaInfoSlice";
import {
  setInitialCalendarData,
  setInitialVisitData,
} from "./components/calendar/CalendarSlice";

export const THEMES = {
  TOKKOBROKER: "tokkobroker",
  UNIVEN: "univen",
};

export const themeFromUniven = (fromUniven) =>
  fromUniven ? THEMES.UNIVEN : THEMES.TOKKOBROKER;

// null = unresolved: no brand until a payload says Tokko or Univen.
const initialState = {
  theme: null,
};

// The brand comes from `from_univen` in each endpoint's response, so the theme
// is set as soon as that payload lands in its slice.
export const ThemeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload;
    },
  },
  extraReducers: (builder) => {
    // A payload without the flag (e.g. the calendar fetched client-side after a
    // visit) must not override a brand that is already resolved.
    const setThemeFromPayload = (state, action) => {
      const { from_univen } = action.payload;
      if (from_univen === undefined && state.theme) return;
      state.theme = themeFromUniven(from_univen);
    };

    builder
      .addCase(setFichaInfoData, setThemeFromPayload)
      .addCase(setInitialCalendarData, setThemeFromPayload)
      .addCase(setInitialVisitData, setThemeFromPayload);
  },
});

export const { setTheme } = ThemeSlice.actions;

export default ThemeSlice.reducer;
